import React from 'react';
import { Link } from 'react-router-dom';
import DownloadButtons from '@/components/DownloadButtons';

export function SiteFooter() {
  return (
    <footer className="border-t border-slate-200/70 bg-white text-slate-900">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-col gap-4">
            <Link to="/" className="inline-flex items-center gap-3">
              <img
                src="/bevpass-letters-blue.svg"
                alt="BevPass"
                className="h-8 w-auto"
                loading="lazy"
              />
            </Link>
            <p className="text-sm text-slate-600">Your daily drink subscription.</p>
            <div className="mt-2 flex flex-col gap-3">
              <span className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">
                Get the app
              </span>
              <DownloadButtons />
            </div>
          </div>
          <div className="flex flex-col gap-2 text-sm text-slate-600 sm:flex-row sm:items-center sm:gap-6">
            <Link className="transition hover:text-slate-900" to="/partners">
              For Merchants
            </Link>
            <Link className="transition hover:text-slate-900" to="/privacy">
              Privacy
            </Link>
            <a className="transition hover:text-slate-900" href="mailto:support@bevpass.com">
              Support
            </a>
            <Link className="transition hover:text-slate-900" to="/auth/login">
              Merchant Login
            </Link>
          </div>
        </div>
        <div className="mt-10 border-t border-slate-200/70 pt-6 text-xs text-slate-400">
          © {new Date().getFullYear()} BevPass. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
